import FlameLogo from "./FlameLogo";

const links = [
  { href: "#services", label: "What I do" },
  { href: "#about", label: "About" },
  { href: "#toolkit", label: "Toolkit" },
];

export default function Navbar() {
  return (
    <header className="t-nav">
      <div className="t-wrap t-nav__inner">
        <a href="#main-content" className="t-wordmark">
          <FlameLogo />
          <span>Firechain</span>
        </a>
        <nav className="t-nav__links" aria-label="Sections">
          {links.map((link) => (
            <a key={link.href} href={link.href} className="t-nav__link">
              {link.label}
            </a>
          ))}
          <a href="/dashboard" className="t-btn t-btn--ghost t-nav__cta">
            Client portal
          </a>
          <a href="#contact" className="t-btn t-nav__cta">
            Contact
          </a>
        </nav>
      </div>
    </header>
  );
}
